import { Slot } from '@radix-ui/react-slot';
import { type Themes } from '@smart/web-foundations';
import React from 'react';
import { ThemeContextProvider, useTheme } from '../../contexts';
import scss from './theme.module.scss';

export type ThemeProps = {
  /** Theme to be applied to children */
  theme?: Themes;
  children?: React.ReactNode;
  asChild?: boolean;
};

/**
 * Will apply specified theme to children. Wrapped components can access them theme via css variables.
 *
 * @link https://prod.web-components.srv.smart.com/?path=/docs/components-theme--docs
 */
export const Theme = React.forwardRef<HTMLDivElement, ThemeProps>(
  ({ theme: initialTheme, asChild, children }, ref) => {
    const { theme: currentTheme } = useTheme();
    const theme = initialTheme ?? currentTheme;

    const Tag = asChild ? Slot : 'div';

    return (
      <ThemeContextProvider theme={theme}>
        <Tag className={scss[theme]} ref={ref}>
          {children}
        </Tag>
      </ThemeContextProvider>
    );
  },
);

Theme.displayName = 'Theme';
